(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poster-combo-offers"] && !Shopify.designMode) return;
  try {
    
  class PosterComboOffers extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-tier]'));
      this.progress = this.querySelector('[data-combo-progress]');
      this.storageKey = `poster-combo-offer-${window.Shopify?.shop || window.location.host}`;
      this.productForms = this.findProductForms();
      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectOffer(card, true));
        card.addEventListener('keydown', (event) => this.handleKeydown(event, card));
      });
      this.restoreOffer();
      this.updateProgress();
      document.addEventListener('cart:updated', () => this.updateProgress());
    }

    findProductForms() {
      const productForm = this.closest('product-information, .product-information, .shopify-section')?.querySelector('form[data-type="add-to-cart-form"]');
      if (productForm) return [productForm];
      return Array.from(document.querySelectorAll(`form[data-type="add-to-cart-form"]`)).filter((form) => {
        const productInput = form.querySelector('input[name="id"]');
        return productInput && form.closest('product-form-component')?.dataset.productId === this.dataset.productId;
      });
    }

    handleKeydown(event, card) {
      const currentIndex = this.cards.indexOf(card);
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.cards.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.cards.length) % this.cards.length;
      if (nextIndex === null) return;
      event.preventDefault();
      this.cards[nextIndex].focus();
      this.selectOffer(this.cards[nextIndex], true);
    }

    async restoreOffer() {
      let offer = null;
      try {
        offer = JSON.parse(window.localStorage.getItem(this.storageKey));
      } catch (error) {
        offer = null;
      }
      const card = offer ? this.cards.find((item) => item.dataset.tier === String(offer.tier)) : this.cards.find((item) => item.dataset.tier === this.dataset.defaultTier);
      if (card) this.selectOffer(card, false);
    }

    async selectOffer(card, shouldSyncCart) {
      const offer = {
        tier: card.dataset.tier,
        quantity: Number(card.dataset.quantity),
        price: card.dataset.price,
        ribbon: card.dataset.ribbon
      };
      this.cards.forEach((item) => {
        const selected = item === card;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      this.offer = offer;
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(offer));
      } catch (error) {
      }
      this.applyLineItemProperties();
      this.updateProgress();
      this.dispatchEvent(new CustomEvent('poster-combo:change', { bubbles: true, detail: offer }));
      if (shouldSyncCart) await this.syncCartAttributes();
    }

    applyLineItemProperties() {
      this.productForms = this.findProductForms();
      this.productForms.forEach((form) => {
        const values = {
          '_poster_combo_tier': this.offer.tier,
          '_poster_combo_target_quantity': String(this.offer.quantity),
          '_poster_combo_price': this.offer.price,
          '_poster_combo_source': 'poster-combo-offers'
        };
        Object.entries(values).forEach(([key, value]) => {
          let input = form.querySelector(`input[data-poster-combo-property="${key}"]`);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            input.dataset.posterComboProperty = key;
            form.appendChild(input);
          }
          input.value = value;
        });
      });
    }

    async syncCartAttributes() {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              poster_combo_tier: this.offer.tier,
              poster_combo_target_quantity: String(this.offer.quantity),
              poster_combo_price: this.offer.price,
              poster_combo_source: 'poster-combo-offers'
            }
          })
        });
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
      }
    }

    async updateProgress() {
      if (!this.offer || !this.progress) return;
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        const selectedQuantity = cart.items.reduce((total, item) => {
          const properties = item.properties || {};
          return properties._poster_combo_tier === this.offer.tier && String(properties._poster_combo_target_quantity) === String(this.offer.quantity) ? total + item.quantity : total;
        }, 0);
        const remaining = Math.max(this.offer.quantity - selectedQuantity, 0);
        if (remaining > 0) {
          this.progress.textContent = `${selectedQuantity} of ${this.offer.quantity} posters added. Add ${remaining} more in any mix.`;
        } else {
          this.progress.textContent = `${this.offer.quantity} of ${this.offer.quantity} posters added. Your ${this.offer.ribbon.toLowerCase()} bundle is ready.`;
        }
      } catch (error) {
        this.progress.textContent = `Selected: Buy any ${this.offer.quantity} for ₹${this.offer.price}. Add posters in any mix.`;
      }
    }
  }

  if (!customElements.get('poster-combo-offers')) customElements.define('poster-combo-offers', PosterComboOffers);

  } catch(e) { console.error(e); }
})();
})();
